import { cardStyles } from "../../../../core/Card.styles.js";
import { Text } from "../../../../core/Text.js";
import { AppLink } from "../../../../foundations/AppLink.js";
import { STRETCHED_LINK } from "../../../../foundations/interaction.js";
import { Section } from "../../../../patterns/Section.js";
import { ActionButton } from "../../../shared/ActionButton.js";
import type { PromoCardsContent } from "../../homeContent.js";

/**
 * Up to three cards that each lead somewhere: a whole-card link, or a card with its own actions.
 * From `md` they share one row, however many there are.
 */
export function HomePromoCards({ cards }: PromoCardsContent) {
  if (cards.length === 0) return null;
  return (
    <Section>
      <ul className="grid gap-3 md:auto-cols-fr md:grid-flow-col md:gap-5">
        {cards.map((card) => (
          <li
            key={card.key}
            className={cardStyles({
              radius: "2xl",
              action: card.kind === "link" ? "link" : "none",
              className: "group relative flex h-full flex-col justify-between gap-6 p-6",
            })}
          >
            <div className="flex flex-col gap-1">
              {card.eyebrow && (
                <Text variant="caption-eyebrow" tone="secondary">
                  {card.eyebrow}
                </Text>
              )}
              <Text as="h3" variant="display-xl4" tone="primary">
                {card.kind === "link" ? (
                  // The whole card is the link, through its title.
                  <AppLink href={card.destination.href} className={STRETCHED_LINK}>
                    {card.title}
                  </AppLink>
                ) : (
                  card.title
                )}
              </Text>
            </div>
            {card.kind === "actions" && card.actions.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {card.actions.map((action) => (
                  <ActionButton
                    key={`${action.href}${action.label}`}
                    action={action}
                    variant={action.emphasis === "primary" ? "primary" : "secondary"}
                    size="sm"
                  />
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
    </Section>
  );
}
